import React, {useContext} from 'react';
import {StyleSheet} from 'react-native';
import config from '../../../config/default-blueprint.json';
import {ThemeContext} from '../../../../../providers/theme';
import {useViewport} from 'react-viewport-provider';
import {OrganizationProfileV} from 'react-organisation-profile';

const BP = config.dashboard;
const EXPANDABLE_WIDTH = 256;

interface IProps {
  opeProfileData?:any;
}

export const OperatorProfile = (props:IProps) => {
  const theme = useContext(ThemeContext);
  const {width, height} = useViewport();
  const styles = StyleSheet.create({
    imageBackgroundstyle: {
        backgroundColor: theme?.palette.ternary,
    }
  });
  
  const handleHeaderEditButtonPress = () => {

  }
  
  return (
    <OrganizationProfileV
      width={'100%'}
      height={0.9 * height}
      image={props?.opeProfileData?.image}
      title={props?.opeProfileData?.title}
      subtitle={props?.opeProfileData?.subtitle}
      leftAvatar={props?.opeProfileData?.leftAvatar}
      headerButtonId={props?.opeProfileData?.headerButtonId}
      headerButtonTitle={props?.opeProfileData?.headerButtonTitle}
      headerButtonColor={theme?.palette.secondary}
      onHeaderButtonPress={handleHeaderEditButtonPress}
      profileDetails={props?.opeProfileData?.profileDetails}
      imageBackgroundStyle={StyleSheet.flatten([styles.imageBackgroundstyle])}
    />
  );
};
